import {ProductOption} from '@teemill/common/models';
import {Thumbnail} from '@teemill/common/classes';

export class BundleItem {
  /**
   * @param {{
   *  baseSku: string
   *  defaultColour: string | null,
   *  id: number,
   *  name: string,
   *  options: ProductOptions[],
   *  sizeChartId: number,
   *  sizeCount: number,
   *  specifications: string
   * }}
   */
  constructor({
    baseSku,
    defaultColour,
    id,
    name,
    options,
    sizeChartId,
    sizeCount,
    specifications,
  } = {}) {
    /**
     * @type {string}
     */
    this.baseSku = baseSku;
    /**
     * @type {string | null}
     */
    this.defaultColour = defaultColour;
    /**
     * @type {number}
     */
    this.id = id;
    /**
     * @type {string}
     */
    this.name = name;
    /**
     * @type {ProductOptions[]}
     */
    this.options = options;
    /**
     * @type {number}
     */
    this.sizeChartId = sizeChartId;
    /**
     * @type {number}
     */
    this.sizeCount = sizeCount;
    /**
     * @type {string}
     */
    this.specifications = specifications;
  }

  /**
   * @type {Thumbnail | undefined}
   */
  get image() {
    return new Thumbnail(Object.values(this.options)[0]?.flatImage);
  }

  /**
   * @type {boolean}
   */
  get hasMoreThanOneColour() {
    return Object.values(this.options).length > 1;
  }

  /**
   * @type {boolean}
   */
  get hasMoreThanOneSize() {
    return Object.values(
      Object.values(this.options).map(option => option.sizes)
    ).some(sizes => Object.keys(sizes).length > 1);
  }

  /**
   * @param {string} colour
   *
   * @return {Thumbnail | null}
   */
  getImageByColour(colour) {
    const matchingOption = Object.values(this.options).filter(
      option => option.colour === colour
    )[0]?.flatImage;

    return matchingOption ? new Thumbnail(matchingOption) : null;
  }
}
